import { Builder } from '@builder.io/react'
import React from 'react'

interface Props {
  backgroundColor: string
  sectionBackgroundColor: string
  mainText: string
  mainTextColor: string
  secondaryText: string
  secondaryTextColor: string
  policyText: string
  policyLink: string
  policyTextEnabled: boolean
  actionButtonText: string
  actionButtonBackgroundColor: string
  actionButtonTextColor: string
}

const NewsLetter = ({
  backgroundColor,
  actionButtonBackgroundColor,
  sectionBackgroundColor,
  mainText,
  mainTextColor,
  actionButtonText,
  policyLink,
  policyText,
  policyTextEnabled,
  secondaryTextColor,
  secondaryText,
  actionButtonTextColor
}: Props) => {
  const getPolicyText = () => {
    if (!policyTextEnabled) return null

    return (
      <p className="mt-3 text-sm text-indigo-200" style={{ color: secondaryTextColor }}>
        {policyText}
        {`  `}
        <a href={policyLink} className="font-medium text-white underline" style={{ color: secondaryTextColor }}>
          Privacy Policy.
        </a>
      </p>
    )
  }

  return (
    <div className="bg-white" style={{ backgroundColor }}>
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:py-8 lg:px-8">
        <div
          className="rounded-lg bg-base px-6 py-6 md:py-12 md:px-12 lg:py-16 lg:px-16 xl:flex xl:items-center"
          style={{ backgroundColor: sectionBackgroundColor }}
        >
          <div className="xl:w-0 xl:flex-1">
            <p
              className="text-3xl font-extrabold tracking-tight text-white sm:text-3xl"
              style={{ color: mainTextColor }}
            >
              {mainText}
            </p>
            <p className="mt-3 max-w-3xl text-lg leading-6 text-indigo-200" style={{ color: secondaryTextColor }}>
              {secondaryText}
            </p>
          </div>
          <div className="mt-8 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8">
            <form className="sm:flex">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email-address"
                type="email"
                autoComplete="email"
                required
                className="w-full rounded-full border-white px-5 py-3 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700"
                placeholder="Enter your email"
              />
              <button
                type="submit"
                className="mt-3 flex w-full items-center justify-center rounded-full border border-transparent bg-indigo-500 px-5 py-3 text-base font-medium text-white shadow hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-700 sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0"
                style={{ backgroundColor: actionButtonBackgroundColor, color: actionButtonTextColor }}
              >
                {actionButtonText}
              </button>
            </form>
            {getPolicyText()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsLetter

Builder.registerComponent(NewsLetter, {
  name: 'NewsLetter',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightgreen'
    },
    {
      name: 'sectionBackgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      name: 'mainText',
      type: 'text',
      defaultValue: 'Want product news and updates?'
    },
    {
      name: 'mainTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'secondaryText',
      type: 'text',
      defaultValue: 'Sign up for our newsletter to stay up to date'
    },
    {
      name: 'secondaryTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'policyText',
      type: 'text',
      defaultValue: 'We care about the protection of your data.'
    },
    {
      name: 'policyLink',
      type: 'text',
      defaultValue: '#'
    },
    {
      name: 'policyTextEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'actionButtonText',
      type: 'text',
      defaultValue: 'Notify me'
    },
    {
      name: 'actionButtonBackgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      name: 'actionButtonTextColor',
      type: 'color',
      defaultValue: 'white'
    }
  ]
})
